export default __webpack_public_path__ + "static/media/multi-factor-passcode-340x340.50901d44.gif";